const _isObject = (obj) => {
    return obj instanceof Object && obj.constructor === Object;
};
const isObject = {
    install(app, options = {}) {
        app.provide("$isObject", _isObject);
    }
};
const _deepEquals = (obj1, obj2) => {
    const isNullish1 = obj1 === undefined || obj1 === null;
    const isNullish2 = obj2 === undefined || obj2 === null;
    if (isNullish1 !== isNullish2)
        return false;
    if (isNullish1)
        return true;
    const isObject1 = _isObject(obj1);
    const isObject2 = _isObject(obj2);
    if (isObject1 !== isObject2)
        return false;
    if (isObject1) {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        if (keys1.length !== keys2.length) {
            return false;
        }
        for (const key of keys1) {
            const val1 = obj1[key];
            const val2 = obj2[key];
            if (!_deepEquals(val1, val2)) {
                return false;
            }
        }
        return true;
    }
    const isArray1 = Array.isArray(obj1);
    const isArray2 = Array.isArray(obj2);
    if (isArray1 !== isArray2)
        return false;
    if (isArray1) {
        if (obj1.length !== obj2.length)
            return false;
        for (let i = 0; i < obj1.length; i++) {
            if (!_deepEquals(obj1[i], obj2[i])) {
                return false;
            }
        }
        return true;
    }
    if (obj1 === obj2)
        return true;
    return false;
};
const deepEquals = {
    install(app, options = {}) {
        app.provide("$deepEquals", _deepEquals);
    }
};
const _clean = (item, ...args) => {
    if (item === undefined || item === null)
        return true;
    if (_isObject(item)) {
        for (const key of Object.keys(item)) {
            if (key.startsWith("_") || (args && args.includes(key))) {
                delete item[key];
                continue;
            }
            const value = item[key];
            if (_clean(value, ...args)) {
                delete item[key];
            }
        }
    }
    else if (Array.isArray(item)) {
        for (const child of item) {
            _clean(child, ...args);
        }
    }
    return false;
};
const clean = {
    install(app, options = {}) {
        app.provide("$clean", _clean);
    }
};
export default { isObject, deepEquals, clean };
